import React, { useState, useEffect, useRef } from 'react';
import StackableCard from '../StackableCard/StackableCard';
import styles from './StackableCarousel.module.css';

import webIntegrationIcon from '../../../assets/svg/ai-sales-landing/web_int_icon.svg';
import phoneIntegrationIcon from '../../../assets/svg/ai-sales-landing/phone_int_icon.svg';
import messageIntegrationIcon from '../../../assets/svg/ai-sales-landing/msg_int_icon.svg';
import instaIntegrationIcon from '../../../assets/svg/ai-sales-landing/insta_int_icon.svg';
import whatsappIntegrationIcon from '../../../assets/svg/ai-sales-landing/whatsapp_int_icon.svg';
import mailIntegrationIcon from '../../../assets/svg/ai-sales-landing/gmail_int_icon.svg';
import messengerIntegrationIcon from '../../../assets/svg/ai-sales-landing/messenger_int_icon.svg';

const StackableCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const containerRef = useRef(null);

  const cardContent = [
    {
      title: 'Omnichannel Engagement with Smart Follow-ups',
      bulletPoints: [
        'Let guests connect effortlessly through voice calls, WhatsApp, website chat, email, Messenger, and more.',
        'Automatically follow up with users who drop off mid-conversation or abandon bookings—so no lead slips through the cracks.',
        'Integrates with',
      ],
      className: 'ominiChannelCard',
      integrationIcons: [
        webIntegrationIcon,
        messageIntegrationIcon,
        phoneIntegrationIcon,
        whatsappIntegrationIcon,
        mailIntegrationIcon,
        messengerIntegrationIcon,
        instaIntegrationIcon,
      ],
      imageUrl: 'Frame-1261155623.mov',
    },
    {
      title: 'Real-Time Updates with a Personal Touch',
      bulletPoints: [
        'Keep guests informed with real-time room availability and pricing across platforms.',
        'Boost engagement with responses personalized to each guest’s booking history, preferences, and intent—creating a smooth and intuitive experience.',
      ],
      className: 'realTimeCard',
      imageUrl: 'b6575790-58b6-414f-8c99-b2c5c50c2da6.mov',
    },
    {
      title: 'Effortless Handling of Guest Requests',
      bulletPoints: [
        'Easily capture and manage special requests—like airport transfers, early check-ins, late check-outs, or room preferences—right within the conversation.',
        'No manual effort needed, just smooth, automated service',
      ],
      className: 'guestRequestCard',
      imageUrl: '44c6ca89-fdb2-4bc8-ad16-61c9492ce883.mov',
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;

      const scrollPosition = window.scrollY;
      const containerPosition = containerRef.current.offsetTop;
      const containerHeight = containerRef.current.offsetHeight;

      const scrollRatio =
        (scrollPosition - containerPosition) /
        (containerHeight - window.innerHeight);
      const newIndex = Math.min(
        Math.max(Math.floor(scrollRatio * cardContent.length), 0),
        cardContent.length - 1
      );

      if (newIndex !== activeIndex) {
        setActiveIndex(newIndex);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [activeIndex, cardContent.length]);

  return (
    <div className={styles.container} ref={containerRef}>
      <h1 className={styles.title}>
        Intelligent Features for Effortless{' '}
        <span className={styles.highlight}>Hospitality</span>
      </h1>

      <div className={styles.cardsContainer}>
        {cardContent.map((feature, index) => (
          <StackableCard
            key={index}
            title={feature.title}
            bulletPoints={feature.bulletPoints}
            className={feature.className}
            imageUrl={feature.imageUrl}
            integrationIcons={feature.integrationIcons}
            isActive={index === activeIndex}
          />
        ))}
      </div>

      {/* <div className={styles.progressIndicator}>
        {cardContent.map((_, index) => (
          <div
            key={index}
            className={`${styles.progressDot} ${
              index === activeIndex ? styles.active : ''
            }`}
            onClick={() => {
              setActiveIndex(index);
              // Scroll to appropriate position to show this card
              if (containerRef.current) {
                const containerPosition = containerRef.current.offsetTop;
                const containerHeight = containerRef.current.offsetHeight;
                const scrollTarget =
                  containerPosition +
                  (containerHeight - window.innerHeight) *
                    (index / (cardContent.length - 1));
                window.scrollTo({
                  top: scrollTarget,
                  behavior: 'smooth',
                });
              }
            }}
          />
        ))}
      </div> */}
    </div>
  );
};

export default StackableCarousel;
